import { Button } from "@hoylu/client-common";
import { clsx } from "clsx";
import React from "react";
import { useSelector } from "react-redux";
import { selectCanAssignProjectToWorkspace } from "../../../selectors/selectCanAssignProjectToWorkspace.selector";
import type { AppState } from "../../../state/root.reducer";
import { selectSelectedWorkspace } from "../../../state/workspaces/workspaces.selector";
import { useI18n } from "../../../utils/hooks/use.i18n";
import { managementPortalBillingUrl } from "../../../utils/management.portal/management.portal.url.selectors";
import { openManagementPortal } from "../../../utils/management.portal/openManagementPortal";
import Styles from "./CreditLimitSection.module.css";

type CreditLimitSectionProps = {
  openDropdown?: () => void;
};

export const CreditLimitSection = ({
  openDropdown,
}: CreditLimitSectionProps) => {
  const t = useI18n();

  const selectedMyWorkspaceMetadata = useSelector(selectSelectedWorkspace);
  const billingUrl = useSelector(managementPortalBillingUrl);
  const canAssignProject = useSelector((state: AppState) =>
    selectCanAssignProjectToWorkspace(state, selectedMyWorkspaceMetadata),
  );

  const learnMore = t("USER_PROFILE_WIDGET.LEARN_MORE");
  const addToProject = t("CREDIT_LIMIT_WARNING_BANNER.ADD_TO_PROJECT");
  const upgrade = t("CREDIT_LIMIT_WARNING_BANNER.BUTTON");

  return (
    <div
      className={Styles.creditLimitSection}
      data-test-id="ws-info-credit-limit-banner"
    >
      <div className={Styles.header}>
        <div className={clsx(Styles.icon, "hoylu-ui-icons-warning")} />
        <span>{t("CREDIT_LIMIT_WARNING_BANNER.TITLE")}</span>
      </div>
      <div className={Styles.buttons}>
        <Button
          additionalStyles={{ color: "var(--theme-text)" }}
          dataTestId="ws-info-plan-redirect-button"
          onClick={() => window.open("https://www.hoylu.com/plans", "_blank")}
          toolTip={learnMore}
          type="secondary"
        >
          {learnMore}
        </Button>
        {canAssignProject && (
          <Button
            dataTestId="ws-info-add-to-project"
            onClick={openDropdown}
            toolTip={addToProject}
            type="primary"
          >
            {addToProject}
          </Button>
        )}
        <Button
          additionalStyles={{ marginRight: 0 }}
          dataTestId="ws-info-billing-redirect-button"
          onClick={() => openManagementPortal(billingUrl)}
          toolTip={upgrade}
          type="primary"
        >
          {upgrade}
          <span>...</span>
        </Button>
      </div>
    </div>
  );
};
